var contextmenu = {
    toggleActive: function ($item, isActive, isHidden) {
        if (isActive === true) {
            $item.removeClass('disabled');
            $item.find('.dropdown-item').removeClass('disabled');
        } else {
            $item.addClass('disabled');
            $item.find('.dropdown-item').addClass('disabled');
        }
        if (isHidden === true) {
            $item.addClass('d-none');
            $item.find('.dropdown-item').addClass('d-none');
        } else {
            $item.removeClass('d-none');
            $item.find('.dropdown-item').removeClass('d-none');
        }
    },
    openContextMenu: function(me, event, selector) {
        var targetEl = me.closest(selector || me.attr('data-contextmenu-click'));
        var $menu = $(me.attr('data-contexttarget'));
        var $menuTarget = $('[data-contextmenu="#' + $menu.attr('id') + '"]');
        contextMenuClickDelegate($menu, $menuTarget, targetEl, event);
    },
};

window.contextmenu = contextmenu;

function contextMenuClickDelegate($menu, $menuTarget, targetEl, event) {
    $menuTarget.data('menu.node', targetEl);
    $(document).bind("keydown.slidein-box", function (event) {
        if (event.which === $.ui.keyCode.ESCAPE) {
            closeFilesMenu($menu, $menuTarget);
        }
    }).bind("mousedown.slidein-box", function (event) {
        // Close menu when clicked outside menu
        if ($(event.target).closest(".ui-menu-item").length === 0) {
            closeFilesMenu($menu, $menuTarget);
        }
    });

    $menu.trigger('open', [$menu, targetEl, event]);
    $menu
        .css("position", "absolute")
        .show()
        .position({my: "left top", at: "right top", of: event.originalEvent || targetEl, collision: "flipfit"});
    $menu.focus();
    $menu.trigger('opened', [$menu, targetEl, event]);
}

function closeFilesMenu($menu, $menuTarget) {
    $(document).unbind("keydown.slidein-box, mousedown.slidein-box");
    $menu.hide();
    $menuTarget.data('menu.node', null);
}

$(document).on('content-ready', function (ev, container) {
    container.find('[data-contextmenu-click]').click(function (event) {
        event.stopPropagation();
        contextmenu.openContextMenu($(this), event);
        return false;
    });

    var $menus = container.find('[data-contextmenu]');
    $.each($menus, function () {
        var $menuTarget = $(this);
        var $menu = $($menuTarget.attr('data-contextmenu'));

        if ($menu) {
            $menu.menu({
                create: function (event, ui) {
                    $(event.target).find('.dropdown-submenu .dropdown-item[href]').click(function (ev) {
                        var contextItem = $(this);
                        contextItem.closest('.ui-menu-item').trigger("click", ev);
                    });
                },
                select: function (event, ui) {
                    event.preventDefault();
                    var contextItem = ui.item.find(">a");
                    if (ui.item.is('.disabled') || ui.item.is('.no-action') || ui.item.is('.dropdown-submenu')) return;
                    //
                    var action = contextItem.attr("href");
                    if (action) {
                        var node = $menuTarget.data('menu.node');
                        var result = $menu.trigger('selected.' + action.replace('#', ''), [node, contextItem]);
                        if (result !== false) {
                            closeFilesMenu($menu, $menuTarget);
                        }
                        return result;
                    }
                    return true;
                }
            }).hide();

            $menuTarget.delegate($menuTarget.attr('data-delegates'), "contextmenu", function (event) {
                var targetEl = $(this);
                contextMenuClickDelegate($menu, $menuTarget, targetEl, event);
                return false;
            });
        }
    });
});
